import React, { useState, useEffect } from 'react';
import NonKioskApp from './NonKiosk';
import UtilService from './UtilServices';
import KioskApp from './KioskApp';
import Loader from './Loader';
import { TrackJS } from 'trackjs';

let deviceIdentifier = undefined;
try {
    deviceIdentifier = UtilService.produceArtificialDeviceIdentifierIfNecessary();
} catch(e) {
    console.error('Unable to set a vanilla identifier for the device', e);
}

try {
    const trackJsToken = process.env.REACT_APP_TRACK_JS_TOKEN;
    TrackJS.install({
        token: trackJsToken + '',
        application: process.env.REACT_APP_TRACK_JS_APPLICATION,
        userId: deviceIdentifier,
    });
    if (deviceIdentifier) {
        TrackJS.addMetadata('artificialDeviceIdentifier', deviceIdentifier);
    }

} catch (error) {
    console.error('Failed to initialize TrackJS:', error);
}

const App: React.FC = () => {
    const [isKioskModeDetected, setIsKioskModeDetected] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [appToken, setAppToken] = useState('');
    const [iframeSrc, setIframeSrc] = useState<string>();
    const iframeForBackendRequests = document.getElementById('PWATokenFrame') as HTMLIFrameElement;

    const verifyKioskMode = async () => {
        try {
            const kioskModeDetectionDiagnosis = await UtilService.diagnoseKioskMode();
            if (kioskModeDetectionDiagnosis?.success && kioskModeDetectionDiagnosis?.pwaAppToken) {
                const { success, pwaAppToken, challengeResponse, error } = kioskModeDetectionDiagnosis;
                setAppToken(pwaAppToken);
                setIsKioskModeDetected(success);
                setIframeSrc(UtilService.whitelistPwaTokenApiUrl({ pwaAppToken, challengeResponse, errors: error }));
            } else {
                console.warn('Kiosk verification failed. Assuming non-kiosk mode', kioskModeDetectionDiagnosis?.pwaAppToken)
                TrackJS.track('Kiosk verification failed. Assuming non-kiosk mode. pwaAppToken: ' + kioskModeDetectionDiagnosis?.pwaAppToken);
                setIframeSrc(undefined);
                setIsKioskModeDetected(false);
            }
        } catch (error) {
            console.error('Error during kiosk verification:', error);
            setIframeSrc(undefined);
            setIsKioskModeDetected(false);
        }
        setIsLoading(false);
    };

    const verificatorCallOnLoading = async () => {
        if (isLoading) {
            try {
                await UtilService.waitForWindowDimensions(10);
            } catch (e) {
                console.error('No dimensions loaded. Giving up.', e);
                setIframeSrc(undefined);
                setIsKioskModeDetected(false);
                setIsLoading(false);
                return;
            }
            await verifyKioskMode();
        }
    }

    useEffect(() => {
        verificatorCallOnLoading();
    }, [isLoading]);

    console.log("iframeSrc", iframeSrc);

    return (
        <div className="App">
            <iframe
                id="PWATokenFrame"
                title='PWATokenFrame'
                name="pwa-token-frame"
                src={iframeSrc}
                style={{ visibility: 'hidden' }}
            />
            {isLoading ?
                <Loader />
                :
                isKioskModeDetected ?
                    <KioskApp pwaAppToken={appToken} iframe={iframeForBackendRequests} /> :
                    <NonKioskApp />}
        </div>
    );
};

export default App;
